// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class SAPService {
  public static async getReservationsSAP(orderObject: string, roleId?: number) {
    try {
      const branchLocal = localStorage.getItem('branchId') || 'null';
      const branchId = JSON.parse(branchLocal)?.id;
      const url = '/SAP';
      const response: AxiosResponse<any> = await axios.get(url, { params: { orderObject, roleId, branchId } });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.userMessage || 'Не вірне значення');
    }
  }

  public static async getOZMSAP(orderObject: string, roleId?: number) {
    try {
      const url = '/SAP/View';
      const response: AxiosResponse<any> = await axios.get(url, { params: { orderObject, roleId } });

      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }
}
